import React, { useState } from 'react'

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000'

export default function ClientPortal() {
  const [step, setStep] = useState('form')  // form | uploading | done | error
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [docType, setDocType] = useState('Bank Statement')
  const [notes, setNotes] = useState('')
  const [file, setFile] = useState(null)
  const [refId, setRefId] = useState('')
  const [dragging, setDragging] = useState(false)
  const [error, setError] = useState('')

  const DOC_TYPES = ['Bank Statement', 'Receipts / Invoices', 'Payroll Records', 'VAT Records', 'Other Documents']

  const handleFile = f => {
    if (f) setFile(f)
  }

  const handleDrop = e => {
    e.preventDefault()
    setDragging(false)
    const f = e.dataTransfer.files[0]
    if (f) setFile(f)
  }

  const handleSubmit = async () => {
    if (!name.trim()) { setError('Please enter your name'); return }
    if (!email.trim()) { setError('Please enter your email'); return }
    if (!file) { setError('Please select a file to upload'); return }
    setError('')
    setStep('uploading')

    try {
      const form = new FormData()
      form.append('client_name', name.trim())
      form.append('client_email', email.trim())
      form.append('document_type', docType)
      form.append('notes', notes.trim())
      form.append('file', file)

      const res = await fetch(`${API}/api/portal/upload`, {
        method: 'POST',
        body: form,
      })

      if (!res.ok) {
        const err = await res.json()
        throw new Error(err.detail || 'Upload failed')
      }

      const data = await res.json()
      setRefId(data.upload_id)
      setStep('done')
    } catch (err) {
      setError(err.message)
      setStep('form')
    }
  }

  return (
    <div style={{ minHeight: '100vh', background: '#0B1929', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 20 }}>

      {/* Logo */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 32 }}>
        <div style={{ width: 38, height: 38, background: '#C9973A', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, fontWeight: 700, color: '#0B1929', fontFamily: 'Georgia, serif' }}>S</div>
        <div>
          <div style={{ fontSize: 18, fontWeight: 600, color: 'white', fontFamily: 'Georgia, serif' }}>Sunshoos Accountants</div>
          <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)' }}>IFA Accredited · East London</div>
        </div>
      </div>

      {/* Card */}
      <div style={{ width: '100%', maxWidth: 480, background: 'white', borderRadius: 16, overflow: 'hidden', boxShadow: '0 24px 80px rgba(0,0,0,0.4)' }}>

        {step === 'done' ? (
          <div style={{ padding: 40, textAlign: 'center' }}>
            <div style={{ fontSize: 52, marginBottom: 16 }}>✅</div>
            <div style={{ fontSize: 20, fontWeight: 600, color: '#1a1a2e', marginBottom: 8 }}>Document received!</div>
            <div style={{ fontSize: 14, color: '#666', lineHeight: 1.6, marginBottom: 20 }}>
              Thank you {name.split(' ')[0]}. Your document has been sent to Sunshoos Accountants for review.
            </div>
            <div style={{ background: '#f4f5f7', borderRadius: 10, padding: '12px 20px', display: 'inline-block', marginBottom: 24 }}>
              <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>Your reference number</div>
              <div style={{ fontSize: 22, fontWeight: 700, color: '#0B1929', fontFamily: 'monospace', letterSpacing: '.1em' }}>{refId}</div>
            </div>
            <div style={{ fontSize: 12, color: '#888', lineHeight: 1.6 }}>
              Keep this reference number. Your accountant will be in touch within 1-2 working days.
            </div>
            <button onClick={() => { setStep('form'); setFile(null); setName(''); setEmail(''); setNotes('') }}
              style={{ marginTop: 24, background: '#0B1929', color: '#C9973A', border: 'none', borderRadius: 9, padding: '10px 24px', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>
              Upload another document
            </button>
          </div>
        ) : (
          <>
            <div style={{ background: '#0B1929', padding: '20px 24px' }}>
              <div style={{ fontSize: 16, fontWeight: 600, color: 'white', marginBottom: 4 }}>Submit a document</div>
              <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)' }}>Upload your bank statement, receipts or other documents securely to your accountant</div>
            </div>

            <div style={{ padding: 24, display: 'flex', flexDirection: 'column', gap: 14 }}>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div>
                  <label style={{ fontSize: 11, fontWeight: 600, color: '#555', display: 'block', marginBottom: 5 }}>YOUR FULL NAME *</label>
                  <input value={name} onChange={e => setName(e.target.value)}
                    placeholder="e.g. John Adeyemi"
                    style={{ width: '100%', border: '0.5px solid #ccc', borderRadius: 8, padding: '9px 12px', fontSize: 13, fontFamily: 'inherit', outline: 'none' }}
                    onFocus={e => e.target.style.borderColor = '#C9973A'}
                    onBlur={e => e.target.style.borderColor = '#ccc'}
                  />
                </div>
                <div>
                  <label style={{ fontSize: 11, fontWeight: 600, color: '#555', display: 'block', marginBottom: 5 }}>EMAIL ADDRESS *</label>
                  <input value={email} onChange={e => setEmail(e.target.value)} type="email"
                    placeholder="e.g. john@example.com"
                    style={{ width: '100%', border: '0.5px solid #ccc', borderRadius: 8, padding: '9px 12px', fontSize: 13, fontFamily: 'inherit', outline: 'none' }}
                    onFocus={e => e.target.style.borderColor = '#C9973A'}
                    onBlur={e => e.target.style.borderColor = '#ccc'}
                  />
                </div>
              </div>

              <div>
                <label style={{ fontSize: 11, fontWeight: 600, color: '#555', display: 'block', marginBottom: 5 }}>DOCUMENT TYPE</label>
                <select value={docType} onChange={e => setDocType(e.target.value)}
                  style={{ width: '100%', border: '0.5px solid #ccc', borderRadius: 8, padding: '9px 12px', fontSize: 13, fontFamily: 'inherit', outline: 'none', background: 'white' }}>
                  {DOC_TYPES.map(t => <option key={t}>{t}</option>)}
                </select>
              </div>

              {/* Upload zone */}
              <div>
                <label style={{ fontSize: 11, fontWeight: 600, color: '#555', display: 'block', marginBottom: 5 }}>FILE *</label>
                <div
                  onClick={() => document.getElementById('portalFile').click()}
                  onDragOver={e => { e.preventDefault(); setDragging(true) }}
                  onDragLeave={() => setDragging(false)}
                  onDrop={handleDrop}
                  style={{ border: `1.5px dashed ${dragging ? '#C9973A' : file ? '#3B6D11' : 'rgba(201,151,58,0.4)'}`, borderRadius: 10, padding: 20, textAlign: 'center', cursor: 'pointer', background: dragging ? 'rgba(201,151,58,0.06)' : file ? 'rgba(59,109,17,0.05)' : 'rgba(201,151,58,0.03)', transition: 'all .2s' }}>
                  {file ? (
                    <>
                      <div style={{ fontSize: 24, marginBottom: 6 }}>📄</div>
                      <div style={{ fontSize: 13, fontWeight: 500, color: '#3B6D11', marginBottom: 3 }}>{file.name}</div>
                      <div style={{ fontSize: 11, color: '#888' }}>{(file.size / 1024).toFixed(1)} KB · click to change</div>
                    </>
                  ) : (
                    <>
                      <div style={{ fontSize: 28, marginBottom: 8 }}>📂</div>
                      <div style={{ fontSize: 13, fontWeight: 500, color: '#1a1a2e', marginBottom: 4 }}>Drop your file here or click to browse</div>
                      <div style={{ fontSize: 11, color: '#999' }}>CSV, PDF, Excel, images — any format accepted</div>
                    </>
                  )}
                  <input id="portalFile" type="file" style={{ display: 'none' }} onChange={e => handleFile(e.target.files[0])} />
                </div>
              </div>

              <div>
                <label style={{ fontSize: 11, fontWeight: 600, color: '#555', display: 'block', marginBottom: 5 }}>NOTES FOR YOUR ACCOUNTANT (optional)</label>
                <textarea value={notes} onChange={e => setNotes(e.target.value)}
                  placeholder="e.g. This is my bank statement for August 2024 to July 2025"
                  rows={2}
                  style={{ width: '100%', border: '0.5px solid #ccc', borderRadius: 8, padding: '9px 12px', fontSize: 13, fontFamily: 'inherit', outline: 'none', resize: 'none' }}
                  onFocus={e => e.target.style.borderColor = '#C9973A'}
                  onBlur={e => e.target.style.borderColor = '#ccc'}
                />
              </div>

              {error && (
                <div style={{ background: '#FFF0F0', border: '0.5px solid #FFCCCC', borderRadius: 8, padding: '9px 12px', fontSize: 12, color: '#A32D2D' }}>
                  ⚠ {error}
                </div>
              )}

              <button onClick={handleSubmit} disabled={step === 'uploading'}
                style={{ background: step === 'uploading' ? '#ccc' : '#0B1929', color: step === 'uploading' ? '#888' : '#C9973A', border: 'none', borderRadius: 9, padding: '12px', fontSize: 14, fontWeight: 600, cursor: step === 'uploading' ? 'not-allowed' : 'pointer', fontFamily: 'inherit', marginTop: 4 }}>
                {step === 'uploading' ? '⏳ Uploading...' : '⬆ Submit document to Sunshoos Accountants'}
              </button>

              <div style={{ fontSize: 11, color: '#aaa', textAlign: 'center', lineHeight: 1.5 }}>
                Your documents are transmitted securely and only visible to Sunshoos Accountants staff.
              </div>
            </div>
          </>
        )}
      </div>

      <div style={{ marginTop: 24, fontSize: 11, color: 'rgba(255,255,255,0.25)', textAlign: 'center' }}>
        Sunshoos Accountants · IFA Accredited · East London<br />
        Powered by Sunshoos AI Agent
      </div>
    </div>
  )
}
